import React, { Children } from 'react'

export const Table = ({ headerRender, children, className }) => {
    return (
        <div className={className}>
            {headerRender}
            {Children.map(children, (child, index) =>
                child
            )}
        </div>
    );
};